import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";

type SubRoute = {
  path: string;
  name: string;
  icon?: React.ReactNode;
};

export type Route = {
  path: string;
  name: string;
  subRoutes?: SubRoute[];
  icon?: React.ReactNode;
};

type SidebarMenuProps = {
  route: Route;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarMenu: React.FC<SidebarMenuProps> = ({ route, isOpen, setIsOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
  }, [isOpen]);

  return (
    <>
      <div className="menu" onClick={toggleMenu}>
        <div className="menu_item">
          {isOpen && <div>{route.name}</div>}
        </div>
        {isOpen && (
          <motion.div
            animate={isMenuOpen ? { rotate: -90 } : { rotate: 0 }}
          >
            <FaAngleDown />
          </motion.div>
        )}
      </div>
      {isMenuOpen && (
        <motion.div>
          {route.subRoutes?.map((subRoute, i) => (
            <motion.div key={i} custom={i}>
              <NavLink to={subRoute.path} className="link">
                <div className="link_text">{subRoute.name}</div>
              </NavLink>
            </motion.div>
          ))}
        </motion.div>
      )}
    </>
  );
};

export default SidebarMenu;
